import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const Home = lazy(() => import('./index'));
const BannerPage = lazy(() => import('./BannerPage/index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/our-service',
    element: <BannerPage title='我们的服务' />
  },
  {
    path: '/function-intro',
    element: <BannerPage title='“蓝格赛商城”功能介绍' />
  },
  {
    path: '/invoice-intro',
    element: <BannerPage title="发票说明" />
  },
  {
    path: '/invoice-manage',
    element: <BannerPage title="发票管理" />
  },
  {
    path: '/delivery-intro',
    element: <BannerPage title="配送说明" />
  },
  {
    path: '/product-check',
    element: <BannerPage title="货物验收" />
  },
  {
    path: '/after-sale',
    element: <BannerPage title="售后政策" />
  },
  {
    path: '/contact-us',
    element: <BannerPage title="联系我们" />
  },
];
